import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["initialFocus", "containers", "features"];
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import E, { useRef as d } from "react";
import { useDisposables as U } from '../../hooks/use-disposables.js';
import { useEvent as v } from '../../hooks/use-event.js';
import { useEventListener as x } from '../../hooks/use-event-listener.js';
import { useIsMounted as g } from '../../hooks/use-is-mounted.js';
import { useOnUnmount as N } from '../../hooks/use-on-unmount.js';
import { useOwnerDocument as I } from '../../hooks/use-owner.js';
import { useServerHandoffComplete as G } from '../../hooks/use-server-handoff-complete.js';
import { useSyncRefs as K } from '../../hooks/use-sync-refs.js';
import { Direction as L, useTabDirection as W } from '../../hooks/use-tab-direction.js';
import { useWatch as b } from '../../hooks/use-watch.js';
import { Features as A, Hidden as O } from '../../internal/hidden.js';
import { history as F } from '../../utils/active-element-history.js';
import { Focus as p, focusElement as f, focusIn as M, FocusResult as V } from '../../utils/focus-management.js';
import { match as k } from '../../utils/match.js';
import { microTask as C } from '../../utils/micro-task.js';
import { forwardRefWithAs as q, render as J } from '../../utils/render.js';
function P(t) {
  if (!t) return new Set();
  if (typeof t == "function") return new Set(t());
  var n = new Set();
  var _iterator = _createForOfIteratorHelper(t.current),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var e = _step.value;
      e.current instanceof HTMLElement && n.add(e.current);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return n;
}
var X = "div";
var _ = function (r) {
  return r[r.None = 1] = "None", r[r.InitialFocus = 2] = "InitialFocus", r[r.TabLock = 4] = "TabLock", r[r.FocusLock = 8] = "FocusLock", r[r.RestoreFocus = 16] = "RestoreFocus", r[r.All = 30] = "All", r;
}(_ || {});
function z(t, n) {
  var e = d(null),
    o = K(e, n),
    l = t.initialFocus,
    c = t.containers,
    _t$features = t.features,
    r = _t$features === void 0 ? 30 : _t$features,
    s = _objectWithoutProperties(t, _excluded);
  G() || (r = 1);
  var i = I(e);
  Y({
    ownerDocument: i
  }, Boolean(r & 16));
  var u = Z({
    ownerDocument: i,
    container: e,
    initialFocus: l
  }, Boolean(r & 2));
  $({
    ownerDocument: i,
    container: e,
    containers: c,
    previousActiveElement: u
  }, Boolean(r & 8));
  var y = W(),
    R = v(function (a) {
      var m = e.current;
      if (!m) return;
      (function (B) {
        return B();
      })(function () {
        var _k;
        k(y.current, (_k = {}, _defineProperty(_k, L.Forwards, function () {
          M(m, p.First, {
            skipElements: [a.relatedTarget]
          });
        }), _defineProperty(_k, L.Backwards, function () {
          M(m, p.Last, {
            skipElements: [a.relatedTarget]
          });
        }), _k));
      });
    }),
    h = U(),
    H = d(!1),
    j = {
      ref: o,
      onKeyDown: function onKeyDown(a) {
        a.key == "Tab" && (H.current = !0, h.requestAnimationFrame(function () {
          H.current = !1;
        }));
      },
      onBlur: function onBlur(a) {
        var _k2;
        var m = P(c);
        e.current instanceof HTMLElement && m.add(e.current);
        var T = a.relatedTarget;
        T instanceof HTMLElement && T.dataset.headlessuiFocusGuard !== "true" && (S(m, T) || (H.current ? M(e.current, k(y.current, (_k2 = {}, _defineProperty(_k2, L.Forwards, function () {
          return p.Next;
        }), _defineProperty(_k2, L.Backwards, function () {
          return p.Previous;
        }), _k2)) | p.WrapAround, {
          relativeTo: a.target
        }) : a.target instanceof HTMLElement && f(a.target)));
      }
    };
  return E.createElement(E.Fragment, null, Boolean(r & 4) && E.createElement(O, {
    as: "button",
    type: "button",
    "data-headlessui-focus-guard": !0,
    onFocus: R,
    features: A.Focusable
  }), J({
    ourProps: j,
    theirProps: s,
    defaultTag: X,
    name: "FocusTrap"
  }), Boolean(r & 4) && E.createElement(O, {
    as: "button",
    type: "button",
    "data-headlessui-focus-guard": !0,
    onFocus: R,
    features: A.Focusable
  }));
}
var D = q(z),
  de = Object.assign(D, {
    features: _
  });
function Q() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
  var n = d(F.slice());
  return b(function (_ref, _ref2) {
    var _ref3 = _slicedToArray(_ref, 1),
      e = _ref3[0];
    var _ref4 = _slicedToArray(_ref2, 1),
      o = _ref4[0];
    o === !0 && e === !1 && C(function () {
      n.current.splice(0);
    }), o === !1 && e === !0 && (n.current = F.slice());
  }, [t, F, n]), v(function () {
    var e;
    return (e = n.current.find(function (o) {
      return o != null && o.isConnected;
    })) != null ? e : null;
  });
}
function Y(_ref5, n) {
  var t = _ref5.ownerDocument;
  var e = Q(n);
  b(function () {
    n || (t == null ? void 0 : t.activeElement) === (t == null ? void 0 : t.body) && f(e());
  }, [n]), N(function () {
    n && f(e());
  });
}
function Z(_ref6, o) {
  var t = _ref6.ownerDocument,
    n = _ref6.container,
    e = _ref6.initialFocus;
  var l = d(null),
    c = g();
  return b(function () {
    if (!o) return;
    var r = n.current;
    r && C(function () {
      if (!c.current) return;
      var s = t == null ? void 0 : t.activeElement;
      if (e != null && e.current) {
        if ((e == null ? void 0 : e.current) === s) {
          l.current = s;
          return;
        }
      } else if (r.contains(s)) {
        l.current = s;
        return;
      }
      e != null && e.current ? f(e.current) : M(r, p.First) === V.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), l.current = t == null ? void 0 : t.activeElement;
    });
  }, [o]), l;
}
function $(_ref7, l) {
  var t = _ref7.ownerDocument,
    n = _ref7.container,
    e = _ref7.containers,
    o = _ref7.previousActiveElement;
  var c = g();
  x(t == null ? void 0 : t.defaultView, "focus", function (r) {
    if (!l || !c.current) return;
    var s = P(e);
    n.current instanceof HTMLElement && s.add(n.current);
    var i = o.current;
    if (!i) return;
    var u = r.target;
    u && u instanceof HTMLElement ? S(s, u) ? (o.current = u, f(u)) : (r.preventDefault(), r.stopPropagation(), f(i)) : f(o.current);
  }, !0);
}
function S(t, n) {
  var _iterator2 = _createForOfIteratorHelper(t),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var e = _step2.value;
      if (e.contains(n)) return !0;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return !1;
}
export { de as FocusTrap };